import React from 'react';
import { Text, Card, Alert } from '@smarterservices/smarter-ui';
import { getStore } from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';
const StudentNotes = (props) => {
  const ExamSession = getStore('examSessionStore');
  return (
    <Card {...props}>
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            Student Notes
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        {ExamSession.sessionData.examConfiguration.studentNotes && (
          <Alert variant="warning" hasShadow={false}>
            <Text variant={CONSTANTS.STYLES.CARD_BODY_TEXT_VARIANT}>
              The test taker has been previously provided these notes. They are
              here for your reference.
            </Text>
          </Alert>
        )}
        <Text variant={CONSTANTS.STYLES.CARD_BODY_TEXT_VARIANT}>
          {ExamSession.sessionData.examConfiguration.studentNotes
            ? ExamSession.sessionData.examConfiguration.studentNotes
            : 'No notes provided'}
        </Text>
      </Card.Body>
    </Card>
  );
};

export default StudentNotes;
